import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex h-screen items-center justify-center" data-testid="auth-loading">
        <div className="font-display text-2xl">POPCRN wird geladen…</div>
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
